// MF-554 — Analytics › Board Builder › Chart Library: browse every chart and card a Board can use.
import { useEffect, useState } from 'react'
import { Box, Typography } from '@mui/material'
import { getLibrary } from '../../../../../services/boards/boards.service'
import { SUMMARY_PALETTE } from '../boardTheme'
import BuilderTabs from '../Builder/BuilderTabs'
import LibraryBrowser from './LibraryBrowser'

const LibraryPage = () => {
  const [items, setItems] = useState(null)
  useEffect(() => {
    getLibrary()
      .then((d) => setItems(d?.items || []))
      .catch(() => setItems([]))
  }, [])
  return (
    <Box sx={{ p: { xs: 2, md: 3 }, minWidth: 0 }}>
      <Typography sx={{ fontSize: 22, fontWeight: 700, color: SUMMARY_PALETTE.ink }}>
        Board Builder
      </Typography>
      <Typography sx={{ fontSize: 13, color: SUMMARY_PALETTE.muted, mb: 1 }}>
        Every chart and card a Board can use. Maestro builds and validates them; each one shows here with
        sample data and the details of where its data comes from and who can see it.
      </Typography>
      <BuilderTabs />
      <LibraryBrowser items={items} />
    </Box>
  )
}

export default LibraryPage
